module.exports = __webpack_public_path__ + "static/media/install_testflight.7fbc9b47.png";